import { render } from "./SwitchLang.vue?vue&type=template&id=15f48757&scoped=true"
import script from "./SwitchLang.vue?vue&type=script&lang=js"
export * from "./SwitchLang.vue?vue&type=script&lang=js"

import "./SwitchLang.vue?vue&type=style&index=0&id=15f48757&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f48757"]])

export default __exports__